const { assign } = Object

import {
    isObject,
    addEventListener,
    mouseWheel,
    checkCursor,
    preventEventDefaults,
    requestAnimationFrame,
    cancelAnimationFrame,
    elementInWindow
} from './uf-functions.js';

class DragEvents {
    constructor(props) {
        if ( !props.element ) return
        
        this.props = props

        const exampleProps = {
            element: false, // html element
            click: false,
            dragging: false,
            vectors: [ 'x' ], // array // [ 'x', 'y', 'z' ]
            affectParent: false,
            wheel: false,

            infinite: false, // fill elements for infinite loop
            
            friction: 1, // number
            animate: false,

            steps: true, // working on it
			animating: { x: .5 } // object // number negative or positive depands on vector
        }
        
        this.setState = this.setState.bind(this)
        this.updateState = this.updateState.bind(this)
        this.init = this.init.bind(this)
        this.render = this.render.bind(this)

        this.fillElements = this.fillElements.bind(this)

        this.focusElement = this.focusElement.bind(this)
        this.focusOutElement = this.focusOutElement.bind(this)

        this.blockClickReset = this.blockClickReset.bind(this)
        this.blockClickOnMove = this.blockClickOnMove.bind(this)

        this.onTouchStart = this.onTouchStart.bind(this)
        this.onTouchMove = this.onTouchMove.bind(this)
        this.onTouchEnd = this.onTouchEnd.bind(this)

        this.setTransition = this.setTransition.bind(this)
        this.setAnimation = this.setAnimation.bind(this)

        this.wheel = this.wheel.bind(this)
        this.wheelStart = this.wheelStart.bind(this)
        this.wheelAct = this.wheelAct.bind(this)
        this.wheelEnd = this.wheelEnd.bind(this)

        this.checkScrollPosition = this.checkScrollPosition.bind(this)

        const { element, vectors, borders } = this.props
        this.parent = element.parentNode
        this.children = [...element.children]
        this.vectorsLength = vectors.length

        this.coreChildrenSizes = [...this.children].map( child => { return { x: child.offsetWidth, y: child.offsetHeight } } )
        this.coreChildrenSize = { x: undefined, y: undefined, z: undefined }
        vectors.map( v => this.coreChildrenSize[v] = this.coreChildrenSizes.reduce( (sum, elem) => sum + elem[v], 0 ) )

        const childrenSizes = this.coreChildrenSizes
        const childrenSize = { x: undefined, y: undefined, z: undefined }
        vectors.map( v => childrenSize[v] = childrenSizes.reduce( (sum, elem) => sum + elem[v], 0 ) )

        const childrenPositions = [...this.children].map( ( child, i ) => { return { x: 0, y: 0, z: 0 } })
        childrenPositions.forEach( ( child, i ) => vectors.map( v => childrenPositions[i][v] = childrenSizes[i][v] - childrenSizes[i][v] * (i + 1) ) )
        
        this.state = {
            event: undefined,
            eventProps: undefined,
            target: undefined,

            wheel_marker: true,
            wheel_counter: 0,
            wheel_delta: undefined,
            wheel_vector: undefined,
            movingDetected: undefined,
            clickDetecting: undefined,
            breakingAnimationMoves: [],
            draggingReady: true,
            dragstart: undefined,
            cursorStartPosition: { x: 0, y: 0, z: 0 },
            lastPoint: undefined,
            lastTime: undefined,
            moveTime: undefined,
            cursorMovePosition: { x: 0, y: 0, z: 0 },
            moving: undefined,
            movingFromStart: undefined,
            averangeSpeed: undefined,
            direction: { x: 0, y: 0, z: 0 },
            elementSize: { x: element.offsetWidth, y: element.offsetHeight, z: 0 },
            parentSize: { x: this.parent.offsetWidth, y: this.parent.offsetHeight, z: 0 },
            onMovePosition: { x: 0, y: 0, z: 0 },
            moveGoalPosition: { x: 0, y: 0, z: 0 },
            elementPosition: { x: 0, y: 0, z: 0 },
            elementPositionPercentage: { x: 0, y: 0, z: 0 },
            elementPositionInfinite: { x: 0, y: 0, z: 0 },
            elementPositionTemporary: { x: 0, y: 0, z: 0 },
            timeOut: undefined,
            animationTimeOut: undefined,
            moveTimeOut: undefined,
            lastTouchMoves: undefined,
            movingStop: undefined,
            v0: { x: 0, y: 0, z: 0 },
            t: { x: undefined, y: undefined, z: undefined },
            S: { x: 0, y: 0, z: 0 },

            childrenSizes: childrenSizes,
            childrenPositions: childrenPositions,
            childrenSize: childrenSize,
            clonedElements: { x: [], y: [], z: [] },
            fillElementsCount: { x: 0, y: 0, z: 0 }, // for log information
        }

        this.init()
    }

    setState(props) {
        assign(this.state, props);
        this.render(this.cb)
    }

    updateState(props) {
        assign(this.state, props);
    }

    init() {
        const { element, dragging, wheel, affectParent, infinite, animating, vectors } = this.props

        this.updateState({ event: 'init' })

        this.checkScrollPosition()
        addEventListener(window, 'scroll', this.checkScrollPosition, false);

        if ( affectParent ) {
            addEventListener(this.parent, 'mouseover',   this.focusElement,     false) // needed on site refresh
            addEventListener(this.parent, 'mouseenter',   this.focusElement,     false)
            addEventListener(this.parent, 'touchstart',   this.focusElement,     false)
            addEventListener(this.parent, 'mouseleave',   this.focusOutElement,  false)
            addEventListener(this.parent, 'touchend',     this.focusOutElement,  false)
        } else {
            addEventListener(element,   'mouseenter',   this.focusElement,          false)
            addEventListener(element,   'touchstart',   this.focusElement,          false)
            addEventListener(element,   'mouseleave',   this.focusOutElement,       false)
            addEventListener(element,   'touchend',     this.focusOutElement,       false)
        }

        addEventListener(document,   'touchstart',   this.blockClickReset,       false)
        addEventListener(document,  'touchmove',    this.blockClickOnMove,      false)
        addEventListener(document,   'mousedown',    this.blockClickReset,       false)
        addEventListener(document,  'mousemove',    this.blockClickOnMove,      false)

        if ( dragging ) {
            if ( affectParent ) {
                addEventListener(this.parent,   'mousedown',    this.onTouchStart,          false)
                addEventListener(this.parent,   'touchstart',   this.onTouchStart,          false)
            } else {
                addEventListener(element,   'mousedown',    this.onTouchStart,          false)
                addEventListener(element,   'touchstart',   this.onTouchStart,          false)
            }
            
            addEventListener(document,  'mousemove',    this.onTouchMove,           false)
            addEventListener(document,  'touchmove',    this.onTouchMove,           false)
            addEventListener(document,  'touchend',     this.onTouchEnd,            false)
            addEventListener(document,  'mouseup',      this.onTouchEnd,            false)
        }

        if ( wheel ) {
            addEventListener(document,  mouseWheel,     this.wheel,                 false)
        }

        
        const loadEvents = event => {
            const { childrenSize } = this.state 

            this.updateState({ 
                childrenSizes: this.children.map( child => ({ x: child.offset().width, y: child.offset().height }) ),
                childrenPositions: this.children.map( ( child, i ) => ({ x: child.offset().width - child.offset().width * (i + 1), y: child.offset().height - child.offset().height * (i + 1) }) ),
            })

            vectors.map( v => childrenSize[v] = this.state.childrenSizes.reduce( (sum, elem) => sum + elem[v], 0 ) )
            this.updateState({
                childrenSize
            })

            if ( infinite ) this.fillElements(this.state.elementPosition)
        }

        addEventListener(window, 'load', e => {
            setTimeout( () => {
                this.setState({ 
                    event: 'load', 
                    eventProps: e 
                })
                
                loadEvents('load')
                animating && isObject(animating) && this.setAnimation(animating)
            }, 1000)
        }, false)
        addEventListener(window, 'resize', e => {
            loadEvents('resize')

            this.setState({
                elementSize: { x: element.offsetWidth, y: element.offsetHeight, z: 0 },
                parentSize: { x: this.parent.offsetWidth, y: this.parent.offsetHeight, z: 0 },
                event: 'resize', 
                eventProps: e
            })
        }, false)
    }

    checkScrollPosition() {
        const { animating } = this.props
        const { animationTimeOut } = this.state

        animationTimeOut && cancelAnimationFrame(animationTimeOut)
        elementInWindow(this.props.element) && animating && isObject(animating) && this.setAnimation(animating)
    } 

    focusElement(e) { 
        this.props.element.addAttr('active_drag', true)
    }

    focusOutElement(e) {
        this.props.element.rmAttr('active_drag')
    }

    blockClickReset() { 
        this.updateState({ movingDetected: false, clickDetecting: true })
    }

    blockClickOnMove() {
        if ( this.state.clickDetecting ) this.updateState({ movingDetected: true, clickDetecting: false })
    }

    onTouchStart(e) {
        const { element, vectors } = this.props
        const { draggingReady, timeOut, elementPosition, animationTimeOut } = this.state

        animationTimeOut && cancelAnimationFrame(animationTimeOut) // stop animations on

        if ( !draggingReady ) return
        if ( !element.hasAttr('active_drag') ) return

        if (e.type.indexOf('mouse') > -1) preventEventDefaults(e)

        timeOut && cancelAnimationFrame(timeOut) // reset touchend animations

        this.updateState({
            dragstart: true,
            lastTime: { x: Date.now(), y: Date.now() },
            moveTime: { x: 0, y: 0, z: 0 },
            cursorStartPosition: checkCursor(e), 
            cursorMovePosition: checkCursor(e),
            lastPoint: checkCursor(e),
            moving: { x: 0, y: 0, z: 0 },
            movingFromStart: { x: 0, y: 0, z: 0 },
            averangeSpeed: 0,
            direction: { x: 0, y: 0, z: 0 },
            lastTouchMoves: [],
            elementPositionTemporary: assign({}, elementPosition)
        })
    }

    onTouchMove(e) {
        const { vectors } = this.props
        const { vectorsLength } = this
        const { 
            dragstart, 
            lastTime, 
            moveTime,
            cursorStartPosition,
            lastPoint, 
            direction,
            lastTouchMoves,
            moving,
            movingFromStart,
            moveTimeOut,
            onMovePosition,
            elementPosition,
            elementPositionInfinite,
            elementPositionTemporary,
            elementSize,
            parentSize,
            childrenSize
        } = this.state
        
        if ( dragstart ) {

            moveTimeOut && cancelAnimationFrame(moveTimeOut) // reset

            const cursorPos = checkCursor(e)

            this.updateState({ movingStop: true })

            vectors.map( v => {
                moveTime[v] = Date.now() - lastTime[v]

                // changing for more dynamic natural move
                // movingFromStart[v] = cursorPos[v] - cursorStartPosition[v]
                // movingFromStart[v] < 0 ? direction[v] = 1 : movingFromStart[v] > 0 ? direction[v] = -1 : direction[v] = 0
                moving[v] = cursorPos[v] - lastPoint[v] // make moving averange from last 5 steps (?)
                moving[v] < 0 ? direction[v] = 1 : moving[v] > 0 ? direction[v] = -1 : direction[v] = 0

                lastTime[v] = Date.now()
                lastPoint[v] = cursorPos[v]
            })
            this.updateState({ direction, moveTime, moving, lastTime, lastPoint })

            let movingDiagonal = 0;
            switch(vectorsLength) {
                case 1 :
                    movingDiagonal = Math.floor( moving[ vectors[0] ] )
                break;
                case 2 :
                    movingDiagonal = Math.floor( Math.sqrt( Math.pow( Math.floor(moving[ vectors[0] ]), 2 ) + Math.pow( Math.floor(moving[ vectors[1] ]), 2 ) ) ) // a2 + b2 = c2
                break;
                // case 3 :
                //     // xy a2 + b2 = c2 than xz a2 + b2 = c2 than xyz Math.sqrt( c2 ) * 2 + Math.sqrt( c2 ) * 2 = d2
                // break;
            }

            const detectMoveSpeed = () => {
                lastTouchMoves.push(movingDiagonal)
                if ( lastTouchMoves.length > 3) lastTouchMoves.shift()
                let averangeSpeedLocal = 0;
                lastTouchMoves.map( val => { averangeSpeedLocal = averangeSpeedLocal + val })
                this.updateState({ averangeSpeed: Math.abs(averangeSpeedLocal) / 3 })

                if ( this.state.averangeSpeed < 1 ) this.updateState({ movingStop: true })

                if (this.state.movingStop) {
                    return
                } else {
                    this.updateState({ moveTimeOut: requestAnimationFrame(detectMoveSpeed) })
                }
            }
            if (this.state.movingStop) {
                this.updateState({ movingStop: false })
                detectMoveSpeed(0)
            }

            // touch moving
            vectors.map( v => {
                onMovePosition[v] = cursorPos[v] - this.state.cursorStartPosition[v]
                elementPosition[v] = elementPositionTemporary[v] + onMovePosition[v]
                elementPositionInfinite[v] = elementPosition[v] % childrenSize[v] - childrenSize[v]
            })

            // setState moving vals
            this.setState({
                cursorMovePosition: cursorPos,
                elementPosition,
                elementPositionInfinite,
                onMovePosition,
                event: 'touchmove',
                eventProps: e
            })
        }
    }

    onTouchEnd(e) {
        const { vectors, animate } = this.props
        let { friction } = this.props

        if ( !friction ) friction = 1

        const { vectorsLength } = this
        const { 
            dragstart, 
            averangeSpeed, 
            moveTime, 
            cursorMovePosition, 
            cursorStartPosition,
            onMovePosition,
            elementPosition,
            moveTimeOut,
            direction,
            v0, S, t,
            movingDetected
        } = this.state

        if ( dragstart ) {
            if (moveTimeOut) cancelAnimationFrame(moveTimeOut)
            
            vectors.map( v => {
                onMovePosition[v] = cursorMovePosition[v] - cursorStartPosition[v]

                if ( !(averangeSpeed === 0 || moveTime[v] === 0) ) {
                    v0[v] = Math.floor( Math.abs( averangeSpeed / moveTime[v] ) * 1000 )
                    t[v] = v0[v] / friction
                    S[v] = Math.floor( ( (friction * Math.pow(t[v], 2) ) / 2) / 1000 )
                }
            })

            this.updateState({ 
                dragstart: false,
                v0, S, t
            })

            let currentMove = { x: 0, y: 0, z: 0 }, 
                moveGoalPosition = { x: 0, y: 0, z: 0 }, 
                stepValue = { x: 0, y: 0, z: 0 }, 
                frames = 0;

            let timeAverage = 0;

            switch(vectorsLength) {
                case 1 :
                    timeAverage = Math.floor( t[ vectors[0] ] )
                break;
                case 2 :
                    timeAverage = Math.floor( Math.sqrt( Math.pow( Math.floor(t[ vectors[0] ]), 2 ) + Math.pow( Math.floor(t[ vectors[1] ]), 2 ) ) ) // a2 + b2 = c2
                break;
                // case 3 :
                //     // xy a2 + b2 = c2 than xz a2 + b2 = c2 than xyz Math.sqrt( c2 ) * 2 + Math.sqrt( c2 ) * 2 = d2
                // break;
            }

            vectors.map( v => {
                frames = Math.floor( timeAverage * 60 * .001 ) // time in ms / 1000 * fps
                stepValue[v] = Math.floor( S[v] / frames )
            })

            let breakingAnimationMoves = new Array()

            for (let currentFrame = 1; currentFrame <= frames; currentFrame++) {

                vectors.map( v => {
                    currentMove[v] = Math.floor(stepValue[v] / frames * (frames - currentFrame));
                    if ( direction[v] === -1 ) moveGoalPosition[v] = moveGoalPosition[v] + currentMove[v] 
                    if ( direction[v] === 1 ) moveGoalPosition[v] = moveGoalPosition[v] - currentMove[v]
                })

                breakingAnimationMoves.push( assign({}, moveGoalPosition) )
            }

            let movingButClick;
            vectors.map( v => { 
                if ( this.state.moving[v] === 0 ) movingButClick = true
            })

            if ( movingButClick ) {
                this.setState({ 
                    breakingAnimationMoves,
                    moveGoalPosition,
                    onMovePosition,
                    elementPositionTemporary: assign({}, elementPosition),
                    event: 'click', 
                    eventProps: e,
                })
            }
            
            if ( movingDetected ) {
                this.setState({
                    breakingAnimationMoves,
                    moveGoalPosition,
                    onMovePosition,
                    elementPositionTemporary: assign({}, elementPosition),
                    event: 'touchend',
                    eventProps: e
                })

                if ( animate ) this.setTransition(breakingAnimationMoves)
            }
        }
    }

    fillElements(position) {
        const { children } = this
        const { element, vectors } = this.props
        const { parentSize, childrenSize } = this.state

        const setClonedElements = { x: [], y: [], z: [] }
        const count = { x: undefined, y: undefined, z: undefined }
            
        vectors.map( v => {
            // how many elements add on left side, how many on right side
            count[v] = Math.abs( Math.ceil( (parentSize[v] + position[v]) / childrenSize[v] ) + Math.ceil( (parentSize[v] - position[v]) / childrenSize[v] ) ) + 1

            const renderMultipled = ( amount, multipled ) => {
                amount = amount - 1
                if ( amount > 0 ) {
                    multipled = multipled.concat(children)
                    return renderMultipled( amount, multipled )
                } else {
                    return multipled
                }
            }
            
            setClonedElements[v] = renderMultipled( count[v], children )
            this.setState({ clonedElements: setClonedElements, fillElementsCount: count })
            
            element.innerHTML = ''
            children.map( child => element.appendChild(child) )
            // console.log( '< --- break --- >' ) 
            this.state.clonedElements[v].map( ( child, index ) => {
                const cloned = document.createElement('div');
                [ ...child.children ].forEach( child => cloned.innerHTML = child.outerHTML );
                [ ...child.attributes ].map( attribute => cloned.setAttribute( attribute.name, attribute.value ) );
                cloned.setAttribute('key', index)

                element.appendChild(cloned) 
            })
            // console.log( '< --- end --- >' ) 
        })
    }

    setTransition(moves) {
        const { vectors, animating } = this.props
        const { onMovePosition, elementPosition, elementPositionInfinite, childrenSize } = this.state
        
        let i = 0,
            position = moves[i],
            frames = moves.length;

        const onMovePositionTemporary = { x: 0, y: 0, z: 0 }
        const elementPositionTemporary = { x: 0, y: 0, z: 0 }
        vectors.map( v => {
            onMovePositionTemporary[v] = onMovePosition[v]
            elementPositionTemporary[v] = elementPosition[v] 
        })

        const animate = () => {
            if (i < frames) {      
                position = moves[i]
                i++
            } else {
                animating && isObject(animating) && this.setAnimation(animating)

                return // end animation
            }
            
            vectors.map( v => {
                onMovePosition[v] = onMovePositionTemporary[v] + position[v] 
                elementPosition[v] = elementPositionTemporary[v] + position[v]
                elementPositionInfinite[v] = (elementPositionTemporary[v] + position[v]) % childrenSize[v] - childrenSize[v]
            })

            this.setState({
                timeOut: requestAnimationFrame(animate),
                onMovePosition,
                elementPosition,
                elementPositionInfinite,
                event: 'animate',
                eventProps: undefined
            })
        }

        animate();
    }

    setAnimation(animating) {
        const { infinite, vectors } = this.props

        if (!animating || !infinite) return

        const animate = e => {
            const { elementPosition, elementPositionInfinite, childrenSize } = this.state

            vectors.map( v => {
                elementPosition[v] = elementPosition[v] - animating[v]
                elementPositionInfinite[v] = (elementPositionInfinite[v] - animating[v]) % childrenSize[v] - childrenSize[v]
            })

            this.setState({ 
                elementPosition,
                elementPositionInfinite,
                animationTimeOut: requestAnimationFrame(animate),
                event: 'animate',
                eventProps: undefined
            })
        }
        animate()
    }

    wheel(e) {
        if ( !this.props.element.hasAttr('active_drag') ) return
        this.updateState({ wheel_counter: this.state.wheel_counter + 1 })
        if ( this.state.wheel_marker ) this.wheelStart(e)
        return false
    }

    wheelStart(e) {
        this.updateState({ wheel_marker: false })
        this.wheelAct(e)

        e = e || window.event

        if ( this.props.element.contains( e.target ) ) {
            let delta = 0,
                vector;

            // chrome
            if (e.wheelDelta) {
                if ( 0 < Math.abs(e.wheelDeltaX) ) {
                    delta = e.wheelDeltaX
                    vector = 'x'
                } else if ( 0 < Math.abs(e.wheelDeltaY) ) {
                    delta = e.wheelDeltaY
                    vector = 'y'
                }
            }

            // firefox
            if (e.detail) {
                if (e.axis == 1) {
                    delta = e.detail * -1
                    vector = 'x'
                } else if (e.axis == 2) {
                    delta = e.detail * -1
                    vector = 'y'
                }
            }
            
            this.setState({ 
                wheel_delta: delta, 
                wheel_vector: vector,
                event: 'wheel',
                eventProps: e
            })
        }
    }

    wheelAct(e) {
        const { wheel_counter } = this.state
        const checkCounter = wheel_counter
        setTimeout( () => checkCounter == wheel_counter ? this.wheelEnd(e) : this.wheelAct(e), 250 )
    }

    wheelEnd() {
        this.updateState({ wheel_marker: true, wheel_counter: 0 })
    }

    render(cb) {
        if (!cb || !this.props || !this.props.element ) return
        this.cb = cb
        cb(this)
    }
}

export default DragEvents

// infinite 3d elements are putted on axis x+y, same as cursor you can move only on axis x+y
// you can rotate a ball in 3d on flat floor

// 3d moving elements its real axis x+y+z

// add steps
// what about sizing elements and row
// fixes - ondrag in different direction than vectors, stop moving